
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/open-xd-file-principle",
      function () {
        return require("private-next-pages/tutorials/open-xd-file-principle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/open-xd-file-principle"])
      });
    }
  